var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/adminUserManagement"
              }
            },
            [_vm._v("Admin User Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("Admin User")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("*Required Fields")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formAccount",
              attrs: {
                "label-width": "180px",
                "label-position": "left",
                model: _vm.formAccount,
                rules: _vm.formAccountRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("User Information")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              on: { change: _vm.changeUserLevel },
                              model: {
                                value: _vm.formAccount.Name,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "Name", $$v)
                                },
                                expression: "formAccount.Name"
                              }
                            },
                            _vm._l(_vm.userList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.fullName,
                                  value: item.employeeId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Last Name" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50", disabled: true },
                            model: {
                              value: _vm.formAccount.lastName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "lastName", $$v)
                              },
                              expression: "formAccount.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "First Name" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50", disabled: true },
                            model: {
                              value: _vm.formAccount.firstName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "firstName", $$v)
                              },
                              expression: "formAccount.firstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email address", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50", disabled: true },
                            model: {
                              value: _vm.formAccount.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "email", $$v)
                              },
                              expression: "formAccount.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Permission")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Level", prop: "userLevel" } },
                        [
                          _c(
                            "el-select",
                            {
                              on: { change: _vm.changeUserLevel },
                              model: {
                                value: _vm.formAccount.userLevel,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "userLevel", $$v)
                                },
                                expression: "formAccount.userLevel"
                              }
                            },
                            _vm._l(_vm.userLevelList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Sales Office", prop: "salesOffice" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: _vm.isSalesOfficeDisabled },
                              on: { change: _vm.changeSalesOffice },
                              model: {
                                value: _vm.formAccount.salesOffice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "salesOffice", $$v)
                                },
                                expression: "formAccount.salesOffice"
                              }
                            },
                            _vm._l(_vm.salesOfficeListFiltered, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { label: "Region", prop: "regions" }
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: _vm.isRegionsDisabled },
                              model: {
                                value: _vm.formAccount.regions,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "regions", $$v)
                                },
                                expression: "formAccount.regions"
                              }
                            },
                            _vm._l(_vm.regionListFiltered, function(
                              item,
                              index
                            ) {
                              return _c(
                                "el-checkbox",
                                { key: index, attrs: { label: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "Permisson" } }, [
                        _c(
                          "div",
                          { staticClass: "table-box" },
                          [
                            _c(
                              "el-row",
                              { staticClass: "table-head" },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "Module" }, [
                                    _c("p", [_vm._v("Module")])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 16 } },
                                  [
                                    _c(
                                      "el-row",
                                      { staticClass: "vu" },
                                      [
                                        _c("el-col", { attrs: { span: 12 } }, [
                                          _c("div", { staticClass: "View" }, [
                                            _c("p", [_vm._v("View")])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("el-col", { attrs: { span: 12 } }, [
                                          _c("div", { staticClass: "Update" }, [
                                            _c("p", [_vm._v("Update")])
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.tableData, function(item, i) {
                              return _c(
                                "el-row",
                                { staticClass: "table-body" },
                                [
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _c("div", { staticClass: "Module" }, [
                                      _c("p", [_vm._v(_vm._s(item.name))])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 16 } },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              staticStyle: { height: "100%" },
                                              on: {
                                                change: _vm.handleCheckAllChange
                                              },
                                              model: {
                                                value: _vm.checkTypeList,
                                                callback: function($$v) {
                                                  _vm.checkTypeList = $$v
                                                },
                                                expression: "checkTypeList"
                                              }
                                            },
                                            _vm._l(item.codes, function(
                                              code,
                                              index
                                            ) {
                                              return _c(
                                                "el-col",
                                                {
                                                  staticClass: "checkbox",
                                                  attrs: { span: 12 }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: { label: code },
                                                      on: {
                                                        change:
                                                          _vm.handleCheckedCitiesChange
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "none" },
                                                        [_vm._v("none")]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v("Save")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1f2800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1f2800","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmsUser/editUser.vue
// module id = null
// module chunks = 